module.exports = __webpack_public_path__ + "static/Curbix-4-6607ba4cba4e05c0dac4ae765d971901.jpg";